import React, { useMemo } from 'react';
import { pick } from 'js/utils/ramda.util';
import { ExportButton } from 'js/components/common/ExportButton';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { useDynamicReducerSelector } from '../../store';

import style from '../../SportsbookGamingHistory.scss';

export const useExportControl = () => {
    const translate = useComponentTranslations();
    const {
        transactions,
        isLoading,
        error,
        isExportLoading
    } = useDynamicReducerSelector(pick([
        'transactions',
        'isLoading',
        'error',
        'isExportLoading'
    ]));
    const onExportClick = hooks.useOnExportClick();
    const isDisabled = isLoading || error || isExportLoading || !transactions.length;

    return useMemo(() => {
        return [{
            id: 0,
            content: (
                <ExportButton
                    onClick={onExportClick}
                    isDisabled={isDisabled}
                    isLoading={isExportLoading}
                    btnText={translate('export')}
                    loadingText={translate('loading')}
                    classNames={{ exportBtn: style.exportBtn, exportBtnIcon: style.exportBtnIcon }}
                />
            )
        }];
    }, [isDisabled, isExportLoading, translate, onExportClick]);
};
